var exports = {
  "i": "xe7b6e3d6--2fa6a7--main",
};

module.exports = exports;
